import React from 'react'
import Img from '../../../img/next.png'
import {
    Container,
    LineWrapper,
    ArrowTipWrapper,
} from './SquigglyArrowPointer.styles'

const SquigglyArrowPointer: React.FC = (): JSX.Element => {
    return (
        <Container>
            {/* Single Sine Wave */}
            <LineWrapper>
                <svg
                    width="100%"
                    height="100%"
                    xmlns="http://www.w3.org/2000/svg"
                    aria-hidden="true"
                >
                    <defs>
                        <pattern
                            id="single-wave-pattern-pointer"
                            x="0"
                            y="0"
                            width="100%"
                            height="100%"
                            patternUnits="objectBoundingBox"
                            viewBox="0 0 100 50"
                            preserveAspectRatio="none"
                        >
                            <path
                                d="M0,25 Q25,0 50,25 T100,25"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                        </pattern>
                    </defs>

                    <rect
                        x="0"
                        y="0"
                        width="100%"
                        height="100%"
                        fill="url(#single-wave-pattern-pointer)"
                    />
                </svg>
            </LineWrapper>
            {/* The Arrow Head  */}
            <ArrowTipWrapper>
                <img
                    src={Img}
                    alt="Next"
                    style={{ height: '80%', width: 'auto' }}
                />
            </ArrowTipWrapper>
        </Container>
    )
}

export default SquigglyArrowPointer
